import ElizaBot from "bot";
import { open as openModal, hide as hideModal } from "modal";

(function() {
  var activePoint = Math.ceil(10 * (screen.height / 100));
  var allImages = $("#images div");
  var allTexts = $("#copies div");
  var allTextsWrapper = $("#copies");
  var textToShow = "";

  window.addEventListener("scroll", manifesto);

  function manifesto() {
    var allVisibleItems = allImages.filter(function() {
      if (isVisible($(this))) return true;
    });
    if (allVisibleItems.length) {
      allImages.addClass("op-half");
      allTexts.addClass("hide");
      textToShow = allVisibleItems[allVisibleItems.length - 1].className.split(
        " "
      )[0];
      allTextsWrapper.find(`.${textToShow}`).removeClass("hide");
      allVisibleItems[allVisibleItems.length - 1].classList.remove("op-half");
    }
  }

  manifesto();

  function isVisible(element) {
    var top_of_element = element.offset().top;
    var bottom_of_element = element.offset().top + element.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();
    if (
      bottom_of_screen > top_of_element + activePoint &&
      top_of_screen < bottom_of_element
    ) {
      return true;
    }
    return false;
  }

  $("#chatform").submit(function(e) {
    e.preventDefault();

    var chatMessage = $("#chatinput").val();

    var eliza = new ElizaBot();
    var initial = eliza.getInitial();
    var elizaResponse = eliza.transform(chatMessage);
    var $messageSection = $("#chatbox .message-section");

    $messageSection.html(
      `${$messageSection.html()}<div class='message'><b>You: </b> <span>${$messageSection
        .text(chatMessage)
        .html()}</span></div>`
    );
    var l = $messageSection.prop("scrollHeight") + 100;
    $messageSection.scrollTop(l);
    setTimeout(function() {
      $messageSection.html(
        `${$messageSection.html()}<div class='message'><b>AAI: </b> <span>${$messageSection
          .text(elizaResponse)
          .html()}</span></div>`
      );
      $messageSection.scrollTop(l);
    }, 500);
    $("#chatinput").val("");
    // $messageSection.scrollTop(l);
  });

  $("#chat-js").click(function() {
    $("#chatbox")
      .css({
        display: "block",
        "pointer-events": "all"
      })
      .animate(
        {
          opacity: 1
        },
        300
      );
  });

  $("#mobheading").click(function() {
    $("#chatbox")[0].style = "";
  });
})();

$(".manifesto-btn").click(function() {
  $("body").css("overflow", "hidden");
});

$(".close").click(function() {
  $("body").css("overflow", "initial");
});

var fbBase = "https://www.facebook.com/sharer/sharer.php?u=";
var twitterBase = "https://twitter.com/intent/tweet";
var linkedinBase = "http://www.linkedin.com/shareArticle?mini=true&url=";
var whatsappBase = "https://web.whatsapp.com/send?text=";
var ShareUrl = window.location.origin + "/non-aadmi-party/";
var completeShareMessage = encodeURIComponent(
  "Abki baar, upvote wali sarkar. @NonAadmiParty is the first AI-powered political party launched by a startup. Our PM candidate AAI will change the political face of India."
);

$("#f-s").click(function() {
  window.open(
    fbBase +
      ShareUrl +
      "&quote=" +
      completeShareMessage +
      "&hashtag=%23NonAadmiParty",
    "facebook-share",
    "width=550,height=235"
  );
  return false;
});

$("#t-s,#support-us,.floating-twitter").click(function() {
  window.open(
    twitterBase +
      "?hashtags=NonAadmiParty" +
      "&text=" +
      completeShareMessage +
      " " +
      ShareUrl,
    "twitter-share",
    "width=550,height=235"
  );
  return false;
});

$("#l-s").click(function() {
  window.open(
    linkedinBase + ShareUrl + "&title=" + completeShareMessage,
    "linkedin-share",
    "width=550,height=235"
  );
  return false;
});

$("#w-s").click(function() {
  var ShareMessage = completeShareMessage + " " + ShareUrl;
  window.open(whatsappBase + ShareMessage);
  return false;
});
